import { render, staticRenderFns } from "./botoes_rodape.vue?vue&type=template&id=0e40b8c1&scoped=true&"
import script from "./botoes_rodape.vue?vue&type=script&lang=js&"
export * from "./botoes_rodape.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/modal.css?vue&type=style&index=0&id=0e40b8c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e40b8c1",
  null
  
)

export default component.exports